<template>
  <div
    class="backHeader"
  >
    <div :class="['actions remove-xd-padding', showBack ? null : 'justify-content-end']">
      <a
        v-if="showBack"
        href="#"
        class="btnBack"
        @click.prevent="onClick"
      >{{ $t('buttons.back') }}</a>
      <div class="action"><slot name="action"></slot></div>
    </div>
    <div class="details">
      <div class="titleContainer">
        <div class="title"><slot name="title"></slot></div>
        <div class="rightActions">
          <div class="count"><slot name="count"></slot></div>
        </div>
      </div>
      <div class="extraDetails"><slot name="extraDetails"></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showBack: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onClick () {
      this.$router.replace({
        name: 'icons-slug'
      })
    }
  }
}
</script>
